module.exports = __webpack_public_path__ + "media/images/athletes/2492-a5300c835116d0bf950c53aa2362cfe5.png";